import { addCommentToCacheV2 } from '@/db/queries';
import { IComment, GunNodeKey } from '@/types';
import { GUN_ENV_NAMESPACE_KEY } from '@/utils/constants';
import { decryptData } from '@/utils/crypto-utils';
import { extractNonceFromMessage } from '@/utils/extractNonceFromMessage';
import { waitForGunData, gunInstance } from '@/utils/gun-utils';
import { useEffect, useState } from 'react';

export const useMigrateComments = ({
  ddocId,
  commentKey,
  isOldDoc,
}: {
  ddocId: string;
  commentKey: string;
  isOldDoc: boolean;
}) => {
  const [fetched, setFetched] = useState<boolean>(false);

  const fetchComments = async (commentNode: any) => {
    const docComments = await waitForGunData(commentNode);
    delete docComments['_'];

    for (const key in docComments) {
      try {
        const chatData: IComment = JSON.parse(docComments[key]);
        const { nonce, encryptedMessage } = extractNonceFromMessage(
          ddocId,
          chatData.message
        );
        const decryptedChattext = await decryptData(
          encryptedMessage,
          commentKey,
          nonce
        );
        chatData.message = decryptedChattext;
        await addCommentToCacheV2({
          ddocId,
          id: key,
          username: chatData.author,
          content: chatData.message,
          selectedContent: chatData.highlightedTextContent,
          createdAt: new Date(chatData.createdAt),
          lastReadTimestamp: null,
          reactions: [],
          replies: [],
          resolved: false,
          deleted: false,
          version: '1',
          contentHash: '',
          highlightYjsDiff: '',
          txHash: '',
        });
        setFetched(true);
      } catch (decryptError) {
        console.log('Error decrypting comment', decryptError);
      }
    }
  };
  const loadCommentsFromGun = async () => {
    const commentNode = gunInstance
      .get(GUN_ENV_NAMESPACE_KEY)
      .get(GunNodeKey.Comments)
      .get(`#${ddocId}`);

    try {
      await fetchComments(commentNode);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (!ddocId || !commentKey || !isOldDoc || fetched) return;
    loadCommentsFromGun();
  }, [ddocId, commentKey, isOldDoc]);
};
